export class CollectionParametersState {
    parameterName = "";
    sysDataTypeID = '';
    defaultValue = "";
    displayName = "";
    description = "";
    isFixed = false;
    description = "";
    listColumnValue = "";
    listColumnLabel = "";
    isMultiSelectList = false;
    dynamicListCollectionID = 0;
    fixedListVariableId = 0;
    parameterTypeCD = "";
    inputFieldTypeCD = "";
    sendAs = null;
    variableUId = null;
    isOptionalParameter = false;
    isSystemDefineVariable = false;
    parseAtClientSide = false;
    parameterValue = "";
    displayOrder = 0;
    enableSavingParameterValue = false;
}

export class DataCollectionState {
    connectionList = [];
    categoryList = [];
    collectionTypeList = [];
    variableList = [];
    fieldTypeList = [];
    dynamicList = [];
    columnList = [];
    columnSchemaList = [];
    basicInfoError = null;
    childCollectionUId = "";
    // collectionTypeObjectError = null;
    // parameterError = null;
    columnSchemaError = null;
    testCollectionError = null;
    cloudCollectionError = null;
    nativeCollectionError = null;
    isTestingConnection = false;
    isStepCollectionParameter = false;
    uiLabel = '';
    connectionUId = "";
    groupName = "";
    childGroupName = "";
    name = "";
    sysCollectionTypeId = '';
    sysConnectionTypeId = '';
    sysCollectionSubTypeId = '';
    sourceName = "";
    sourceNamePart2 = "";
    sourceNamePart4 = "";
    categoryUId = "";
    columnSchema = "";
    isCollectionAsDataSource = false;
    hasPrintableCollection = false;
    collectionParameters = [];
    collectionColumns = [];
    displayFormatList = [];
    sortedColumnList = [];
    testedDataList = [];
    testedDataColumnKeys = [];
    testedDataTransformedList = [];
    testedDataTransformedColumneKeys = [];
    prevStepRef = null;
    prevCollection = null;
    rESTRequestMethod = null;
    uId = "";
    restBody = "";
    restSendAsCD = null;
    restDataTransformationScript = null;
    templateCollectionId = null;
    collectionColumnSchema = null;
    cloudCollectionObjects = [];
    isFilterSupported = false;
    isSortSupported = false;
    areAllFieldsFilterable = false;
    areAllFieldsSortable = false;
    isPagingSupported = false;
    columnApiEndpoint = "";
    variableId = null;
    collectionFilterColumns = [];
    returnRawData = false;
    restRequestMethod = null;
    combineMergedParameters = false;
    mergeScript = ""; 
    selectedTypeScript = "";
    dataTransformationScriptId = null;
    dataStylingScriptId = null;
    dataStylingScript = null;
    savedParameterValue = null;
    cloudDataTransformationScript = null;
    collectionUIdsToMerge = [];
    flattenLikeSql = false;
    excludedProperties = "";
    gptPrompt = "";
    cloudObjectChanged = false;
}

export class DataCollectionModal {
    connectionUId = "";
    groupName = "";
    childGroupName = "";
    name = "";
    sysCollectionTypeId = '';
    sysConnectionTypeId = '';
    sysCollectionSubTypeId = '';
    sourceName = "";
    sourceNamePart2 = "";
    sourceNamePart4 = "";
    categoryUId = "";
    columnSchema = "";
    isCollectionAsDataSource = false;
    hasPrintableCollection = false;
    collectionParameters = [];
    collectionColumns = [];
    uId = "";
    restRequestMethod = null;
    restBody = "";
    restSendAsCD = null;
    restDataTransformationScript = null;
    templateCollectionId = null;
    variable = null;
    isFilterSupported = false;
    isSortSupported = false;
    isPagingSupported = false;
    areAllFieldsFilterable = false;
    areAllFieldsSortable = false;
    columnApiEndpoint = "";
    columnSchemaList = [];
    variableId = null;
    collectionFilterColumns = [];
    returnRawData = false;
    hasMergeCollections = false
    collectionUIdsToMerge = []
    combineMergedParameters = false;
    mergeScript = "";
    selectedTypeScript = "";
    dataTransformationScriptId = null;
    dataStylingScriptId = null;
    dataStylingScript = null;
    savedParameterValue = null;
    useTemplateConnection = false;
    flattenLikeSql = false;
    excludedProperties = "";
    childTemplateInheritedCollectionId = null;
    gptPrompt = "";
}

export class CollectionFilterColumn {
    collectionId = null;
    uId = "";
    columnName = "";
    hasMultiSelection = false;
    operators = "";
    variableUId = "";
    variableName = "";
}



export class MergeCollectionState {
    selectedObjectCollections = []
    sqlQueryValue = ''
}

